import S from './BroadcastQueueStyles';
import type { StatusTab as StatusTabType } from './types';

type Props = {
  tabs: StatusTabType[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
};

export default function StatusTabs({ tabs, activeTabId, onTabChange }: Props): JSX.Element {
  return (
    <S.TabsList role="tablist">
      {tabs.map((tab) => (
        <S.TabItem
          key={tab.id}
          role="tab"
          $active={activeTabId === tab.id}
          onClick={(): void => onTabChange(tab.id)}
          onKeyDown={(e): void => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onTabChange(tab.id);
            }
          }}
          tabIndex={activeTabId === tab.id ? 0 : -1}
        >
          {tab.label} ({tab.count})
        </S.TabItem>
      ))}
    </S.TabsList>
  );
}
